import { render, staticRenderFns } from "./BottomNav.vue?vue&type=template&id=be998c6a&scoped=true"
import script from "./BottomNav.vue?vue&type=script&lang=js"
export * from "./BottomNav.vue?vue&type=script&lang=js"
import style0 from "./BottomNav.vue?vue&type=style&index=0&id=be998c6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be998c6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be998c6a')) {
      api.createRecord('be998c6a', component.options)
    } else {
      api.reload('be998c6a', component.options)
    }
    module.hot.accept("./BottomNav.vue?vue&type=template&id=be998c6a&scoped=true", function () {
      api.rerender('be998c6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/appBar/BottomNav.vue"
export default component.exports